import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20
  },
}));
const SubLoader = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <CircularProgress size={30} />
    </div>
  );
};

export default SubLoader;
